import BaseReportTableModel from '../common/base-report-table-model'
import InitiaiveReportDataExtractor from './initiative-report-data-extractor'

/**
 * The data model representing the report table for scorecard report
 */
const InitiativeReportTableModel = BaseReportTableModel.extend({

	_drilldownSection: function() {
		return 'initiatives'
	},

	dataExtractor: function(model) {
		return new InitiaiveReportDataExtractor(model)
	}

})

export default InitiativeReportTableModel
InitiativeReportTableModel.__filename__ = 'reports/initiative-report/initiative-report-table-model.js'
